import React from "react";
import { Link } from "react-router-dom";
import { Car, ArrowLeft } from "lucide-react";

const PoliticaConfidentialitate = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-100 py-4">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2" data-testid="privacy-logo">
            <div className="w-10 h-10 bg-emerald-500 rounded-xl flex items-center justify-center">
              <Car className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg text-gray-900 leading-tight">AUTO PRO</span>
              <span className="text-xs text-emerald-600 font-medium -mt-1">DAUNE</span>
            </div>
          </Link>
          <Link to="/" className="ml-auto flex items-center gap-1 text-sm text-gray-500 hover:text-emerald-600" data-testid="privacy-back">
            <ArrowLeft className="w-4 h-4" />Inapoi
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12" data-testid="privacy-page">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politica de Confidentialitate</h1>
        <p className="text-sm text-gray-400 mb-8">Ultima actualizare: Aprilie 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. Operatorul de date</h2>
            <p><strong>SC AUTO PRO DAUNE & ASIGURARI SRL</strong> (CUI: 49492739, J40/1769/2024) este operatorul datelor cu caracter personal colectate prin intermediul site-ului autoprodaune.ro, in conformitate cu Regulamentul (UE) 2016/679 (GDPR).</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. Ce date colectam?</h2>
            <p>Colectam urmatoarele categorii de date personale:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Date de identificare:</strong> Nume si prenume, adresa de email, numar de telefon</li>
              <li><strong>Date despre eveniment:</strong> Orasul, tipul de dauna (RCA/CASCO), descrierea evenimentului</li>
              <li><strong>Documente:</strong> Fotografii ale vehiculului, acte, documente relevante pentru dosar</li>
              <li><strong>Date tehnice:</strong> Adresa IP, tipul browserului, cookie-uri tehnice</li>
              <li><strong>Date afiliat:</strong> Nume, email, telefon, cod de afiliere (pentru partenerii programului de afiliere)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. Scopul prelucrarii datelor</h2>
            <p>Datele sunt prelucrate in urmatoarele scopuri:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Contactarea clientului si oferirea serviciilor de consultanta</li>
              <li>Gestionarea dosarelor de despagubire</li>
              <li>Comunicari legate de statusul dosarului</li>
              <li>Gestionarea programului de afiliere</li>
              <li>Imbunatatirea serviciilor noastre</li>
              <li>Respectarea obligatiilor legale</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. Temeiul juridic al prelucrarii</h2>
            <p>Prelucrarea datelor se bazeaza pe:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Consimtamantul explicit</strong> al persoanei vizate (Art. 6(1)(a) GDPR)</li>
              <li><strong>Executarea unui contract</strong> sau masuri precontractuale (Art. 6(1)(b) GDPR)</li>
              <li><strong>Obligatii legale</strong> ale operatorului (Art. 6(1)(c) GDPR)</li>
              <li><strong>Interesul legitim</strong> al operatorului (Art. 6(1)(f) GDPR)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. Unde stocam datele?</h2>
            <p>Datele cu caracter personal sunt stocate pe servere securizate, in baze de date MongoDB, gestionate prin intermediul platformei de hosting. Documentele incarcate sunt stocate pe servere protejate cu acces restrictionat. Toate datele sunt stocate in conformitate cu standardele de securitate aplicabile.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. Cat timp pastram datele?</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Datele clientilor:</strong> Pe durata gestionarii dosarului si inca 3 ani dupa finalizare, conform obligatiilor legale</li>
              <li><strong>Datele afiliatilor:</strong> Pe durata colaborarii si inca 3 ani dupa incetarea colaborarii</li>
              <li><strong>Documentele incarcate:</strong> Pe durata gestionarii dosarului si inca 3 ani dupa finalizare</li>
              <li><strong>Cookie-uri:</strong> Conform duratei specificate in Politica de Cookie-uri</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">7. Drepturile persoanei vizate</h2>
            <p>Conform GDPR, aveti urmatoarele drepturi:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Dreptul de acces</strong> la datele dumneavoastra personale</li>
              <li><strong>Dreptul la rectificare</strong> a datelor incorecte</li>
              <li><strong>Dreptul la stergere</strong> ("dreptul de a fi uitat")</li>
              <li><strong>Dreptul la restrictionarea prelucrarii</strong></li>
              <li><strong>Dreptul la portabilitatea datelor</strong></li>
              <li><strong>Dreptul de opozitie</strong> la prelucrarea datelor</li>
              <li><strong>Dreptul de a depune plangere</strong> la Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (ANSPDCP)</li>
            </ul>
            <p className="mt-3">Pentru exercitarea acestor drepturi, contactati-ne la: <strong>office@autoprodaune.ro</strong></p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">8. Transferul datelor catre terti</h2>
            <p>Datele pot fi transmise catre:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Companii de asigurari (in scopul gestionarii dosarului)</li>
              <li>Furnizori de servicii tehnice (hosting, email)</li>
              <li>Autoritati publice (cand legislatia impune)</li>
            </ul>
            <p className="mt-2">Nu vindem si nu inchiriem datele dumneavoastra personale catre terti.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">9. Securitatea datelor</h2>
            <p>Implementam masuri tehnice si organizatorice adecvate pentru protejarea datelor personale, inclusiv: criptarea parolelor, acces pe baza de token JWT, restrictionarea accesului la documente si monitorizarea accesului la date.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">10. Contact DPO</h2>
            <p>Pentru orice intrebari privind prelucrarea datelor personale:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Email: <strong>office@autoprodaune.ro</strong></li>
              <li>Telefon: <strong>0725 399 235</strong></li>
              <li>Adresa: Bucuresti, Romania</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PoliticaConfidentialitate;
